module.exports = __webpack_public_path__ + "img/1F60E.b0461262.svg";